export default __webpack_public_path__ + "static/Plots0056-fe8645802fbc4f7739998a05d230a1de.jpg";